import React, { Component } from "react";
import { connect } from "react-redux";
import { Panel } from "react-bootstrap";
import _ from "lodash";
import moment from "moment";
import FontAwesome from "react-fontawesome";
import Plot from "react-plotly.js";
import { Link } from "react-router-dom";
import { history } from "../../_helpers";
import { api } from "../../_services";

import "./index.css";

class DashboardNotes extends Component {
  constructor(props) {
    super(props);
    this.state = {
      chartData: [],
      startTime: moment().subtract(7, "d"),
      listLoading: true,
      listLoading2: true,
    };
  }

  componentDidMount = () => {
    this.getDashboardNotes({
      ...(this.props.currentPrecinct && this.props.currentPrecinct.id && { "precinct": this.props.currentPrecinct.id }),
    });
  }

  componentWillReceiveProps = (nextProps) => {
    if (this.props.currentPrecinct !== nextProps.currentPrecinct && nextProps.currentPrecinct) {
      this.getDashboardNotes({
        ...(nextProps.currentPrecinct && nextProps.currentPrecinct.id && { "precinct": nextProps.currentPrecinct.id }),
      });
    } else if (this.props.reloadCount !== nextProps.reloadCount) {
      this.getDashboardNotes({
        ...(this.props.currentPrecinct.id && { "precinct": this.props.currentPrecinct.id }),
      });
    }
  }

  /* Retrieve dashboard notes by precincts */
  getDashboardNotes = p => {
    this.setState(() => {
      return {
        listLoading2: true,
      };
    });
    const url = "/api/v1/stats/notes/";
    const params = {};
    if (p) {
      for (const key in p) {
        params[key] = p[key];
      }
    }
    const errorMsg = "Unable to retrieve dashboard notes.";
    params.period_start = moment().startOf("day").subtract(7, "d").format();
    api.getFetch(url, params, this.props.user.token, errorMsg).then(json => {
      this.setState(() => {
        return {
          data: json,
          listLoading: false,
          listLoading2: false,
        };
      });
    });
  };

  clickEvent = (data) => {
    let noteTypeID = "";
    for (let i = 0; i < data.points.length; i++) {
      noteTypeID = data.points[0].id;
    }
    const precinctId = this.props.currentPrecinct.id > 0 ?
      "?precincts=" + this.props.currentPrecinct.id : "";
    console.log("This note type ID:\n\n" + noteTypeID);
    history.push("/notes" + precinctId);
  }

  renderChart = (data) => {
    const resolutionArray = [
      {
        id: "external_source",
        name: "External<br>source",
        value: 0,
      }, {
        id: "local_interference",
        name: "Local<br>interference",
        value: 0,
      }, {
        id: "no_works",
        name: "No CYP <br>works at <br>this time",
        value: 0,
      }, {
        id: "management_action_taken",
        name: "Management<br>action taken",
        value: 0,
      }, {
        id: "planned_exceedence",
        name: "Planned<br>to exceed",
        value: 0,
      }, {
        id: "other",
        name: "Other",
        value: 0,
      }, {
        id: "null",
        name: "Unresolved",
        value: 0,
      },
    ];
    const resolutionData = [];
    resolutionArray.forEach(function (val) {
      if (data[val.id] && data[val.id] > 0) {
        val.value = data[val.id];
        resolutionData.push(val);
      }
    });
    // output data seperately to value and name only array for the chart.
    const arrayValue = _.map(_.uniqBy(resolutionData, "id"), "value");
    const arrayName = _.map(_.uniqBy(resolutionData, "id"), "name");
    if (arrayValue.length > 0 && arrayName.length > 0) {
      const chartConfig = {
        displaylogo: false,
        modeBarButtonsToRemove: [
          "zoom2d", "pan2d", "select2d", "lasso2d", "zoomIn2d", "zoomOut2d", "autoScale2d", "resetScale2d",
          "hoverClosestCartesian", "hoverCompareCartesian",
          "zoom3d", "pan3d", "resetCameraDefault3d", "resetCameraLastSave3d", "hoverClosest3d",
          "orbitRotation", "tableRotation",
          "zoomInGeo", "zoomOutGeo", "resetGeo", "hoverClosestGeo",
          "toImage",
          "sendDataToCloud",
          "hoverClosestGl2d",
          "hoverClosestPie",
          "toggleHover",
          "resetViews",
          "toggleSpikelines",
          "resetViewMapbox"
        ]
      };
      const chartLayout = {
        autosize: true,
        showlegend: false,
        margin: {
          l: 50,
          r: 50,
          b: 60,
          t: 50,
          pad: 8
        },
      };
      const chartData = [{
        values: arrayValue,
        labels: arrayName,
        marker: {
          colors: [
            "#ffcb02",
            "#b7e344",
            "#09d08a",
            "#2196f3",
            "#7552de",
            "#f05151",
            "#ffa700",
          ]
        },
        ids: [1, 2, 3, 4, 5, 6, 7],
        hoverinfo: "label+percent",
        hole: .6,
        type: "pie",
        text: "percent",
        textinfo: "label+'('+value+')'",
        textposition: "outside",
        textfont: {
          size: 10,
        },
      }];
      return (
        <Plot
          className="chartDiagram"
          data={chartData}
          layout={chartLayout}
          config={chartConfig}
          useResizeHandler={true}
          onClick={this.clickEvent}
        />
      );
    } else {
      return (
        <div className="chartDiagram emptyCon">No notes have been resolved in the last 7 days</div>
      );
    }
  }

  setOpenLevel = (val) => {
    const { precinct } = this.state.data;
    if (precinct && val > precinct.open_note_limit_critical) {
      return "color-critical";
    } else if (precinct && val > precinct.open_note_limit_warning) {
      return "color-warning";
    } else {
      return "color-normal";
    }
  }

  setResolvedLevel = (val) => {
    const { precinct } = this.state.data;
    if (precinct && val > precinct.resolved_note_limit_critical) {
      return "color-critical";
    } else if (precinct && val > precinct.resolved_note_limit_warning) {
      return "color-warning";
    } else {
      return "color-normal";
    }
  }

  render() {
    const { configList } = this.props;
    const { startTime, data, listLoading, listLoading2 } = this.state;
    if (!configList) {
      return null;
    }
    if (listLoading || !data) {
      return (
        <Panel className="panel-length dashboardNotes">
          <div className="loading2" />
        </Panel>
      );
    }
    const precinctsLink = (this.props.currentPrecinct && this.props.currentPrecinct.id) ? "&precincts=" + this.props.currentPrecinct.id : "";

    return (
      <Panel className="panel-length dashboardNotes">
        <div className="panel-title">Notes {listLoading2 && <FontAwesome className="loadingIcon" name="spinner" spin />}</div>
        <div className="panel-body">
          <div className="margin-btm flex-row">
            <div className="flex-col noteResolution">
              <Link to={"/notes?status=open" + precinctsLink} title="Unresolved">
                <div className="subTitle">Unresolved</div>
                <div className={"valueCon " + this.setOpenLevel(data.current.note_counts_by_status.open)}>{data.current.note_counts_by_status.open}</div>
              </Link>
            </div>
            <div className="flex-col noteResolution">
              <Link to={"/notes?status=resolved" + precinctsLink} title="Pending sign-off">
                <div className="subTitle">Pending sign-off</div>
                <div className={"valueCon " + this.setResolvedLevel(data.current.note_counts_by_status.resolved)}>{data.current.note_counts_by_status.resolved}</div>
              </Link>
            </div>
          </div>
          <div className="title">Resolution reason</div>
          <div className="subTitle2">{startTime.format("dddd DD MMMM YYYY")} to today (7 days)</div>
          <div>{this.renderChart(data.within_period.notes_resolved_with_resolution_category)}</div>
        </div>
      </Panel>
    );
  }
}

function mapStateToProps(state) {
  const { configList } = state.configuration;
  const { user } = state.authentication;
  return {
    configList,
    user
  };
}

export default connect(mapStateToProps)(DashboardNotes);



// WEBPACK FOOTER //
// ./src/_components/DashboardNotes/index.js